import { Fragment } from "react";
import { useSelector } from "react-redux";
import { WeekOfTheYearKey } from "classes/WeekOfTheYearKey"
import { WorkoutTemplateNames } from "functions/weeklyCalendarUtils"

import FutureWorkoutPhaseComponent from "components/TrainingChart/Body/WorkoutComponents/FutureWorkoutPhaseComponent"

export default function FutureWorkoutComponent({
    weekOfTheYearKey,
    workoutTemplateKey,
    programTableColumn,
    isPresent = false
}) {
    const presentWeekOfTheYearKey = useSelector(state => state.trainingChart.trainingChartPresentWeekOfTheYearKey)
    const trainingChartPhaseFilter = useSelector(state => state.trainingChart.filters.phaseFilter)

    return (
        <div
            className={`
                flex flex-col border border-gray-400 divide-y divide-gray-400 rounded-lg overflow-hidden
                ${isPresent ? 'outline outline-[2px] outline-orange-300 outline-offset-[-1px]' : ''}
            `}
        >
            <div className="p-4 flex flex-col justify-center items-center text-sm text-center space-y-2 bg-gray-200">

                {/* Active Week Icon */}
                {new WeekOfTheYearKey(presentWeekOfTheYearKey).equals(new WeekOfTheYearKey(weekOfTheYearKey)) &&
                    <div className="p-0.5">
                        <svg width="20" height="20" style={{ display: "block" }} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#99a1af" strokeWidth="2.5" />
                        </svg>
                    </div>
                }

                {/* Future Week Icon */}
                {!new WeekOfTheYearKey(presentWeekOfTheYearKey).equals(new WeekOfTheYearKey(weekOfTheYearKey)) &&
                    <div className="p-0.5">
                        <svg width="20" height="20" style={{ display: "block" }} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#99a1af" strokeWidth="2.5" />
                        </svg>
                    </div>
                }

                <div>{WorkoutTemplateNames[workoutTemplateKey]}</div>
            </div>

            {programTableColumn && programTableColumn.exerciseData[workoutTemplateKey].map((phase, phaseIndex) => (
                <Fragment key={phaseIndex}>
                    {trainingChartPhaseFilter.includes(phase.name) &&
                        <FutureWorkoutPhaseComponent
                            weekOfTheYearKey={weekOfTheYearKey}
                            workoutTemplateKey={workoutTemplateKey}
                            phaseIndex={phaseIndex}
                            phase={phase}
                            slotSpecificVolumeData={programTableColumn.volumeData.setsAndRepsData[workoutTemplateKey][phaseIndex]}
                        />
                    }
                </Fragment>
            ))}
        </div>
    )

}